export function formatMessageData(conversationId, userId, content, position, content_type = "normal", dateTime) {
    const formattedDateTime = dateTime ? new Date(dateTime).toISOString() : new Date().toISOString();

    return {
        "conversation_id": conversationId,
        "user_id": userId,
        "content_type": content_type,
        "content": content,
        "position": position,
        "created_at": formattedDateTime
    };
}

export function formatAmount(amount) {
    const formattedAmount = Number(amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return formattedAmount;
}
